import { media } from 'src/common/styles/breakpoints';
import styled, { css } from 'styled-components';

const MainPageConsentsContainer = styled.div`
  width: 100%;
  border-radius: 8px;
  background: ${({ theme }) => theme.consents.container.bg};
  padding: 1rem;
  margin-top: 1.5rem;

  ${media.w.min.px768(css`
    max-width: 47.5%;
  `)};

  ${media.w.min.px1366(css`
    padding: 2rem 2.5rem;
    margin: 0;
    max-width: 36.875rem;
  `)};
`;

export default MainPageConsentsContainer;
